<template>
	<LayoutTableCommonRow>
		<LayoutTableCommonPartText :text="synchronizer.name" :header="dateFormatted" />
		<LayoutTableCommonPartMenu>
			<template #options>
				<router-link :to="{ name: 'company.admin.synchronizer.form', params: { id: synchronizer.id }}" class="dropdown-item rounded-0">Editar</router-link>
				<router-link :to="{ name: 'company.admin.synchronizer.token', params: { id: synchronizer.id }}" class="dropdown-item rounded-0" v-if="synchronizer.type == 'api'">Token</router-link>
				<a href="javascript:void(0)" class="dropdown-item rounded-0" @click="remove">Eliminar</a>
			</template>
		</LayoutTableCommonPartMenu>
	</LayoutTableCommonRow>
</template>

<script>
	import { computed } from 'vue';
	import _ from 'lodash';
	import moment from 'moment';

	export default {
		emits: ['remove'],
		props: {
			synchronizer: Object
		},
		setup(props, { emit }) {
			const dateFormatted = computed(() => moment(props.synchronizer.created_at).format('DD/MM/YYYY'));
			const remove = () => emit('remove', props.synchronizer);

			return { dateFormatted, remove };
		}
	}
</script>